import Button from 'carbon-react/lib/components/button';
import Form from 'carbon-react/lib/components/form';
import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  onClose: () => void;
  onSubmit: () => Promise<void>;
  closeLabel: ReactNode;
  submitLabel: ReactNode;
  submitDisabled?: boolean;
}

export const AssistantSidePanelFormContainer = ({
  children,
  onClose,
  onSubmit,
  submitDisabled,
  closeLabel,
  submitLabel
}: Props) => (
  <Form
    rightSideButtons={
      <>
        <Button buttonType="secondary" onClick={onClose}>
          {closeLabel}
        </Button>
        <Button buttonType="primary" onClick={onSubmit} disabled={submitDisabled}>
          {submitLabel}
        </Button>
      </>
    }
    stickyFooter
    buttonAlignment="right"
    footerPadding={{
      p: 2
    }}
    onSubmit={e => e.preventDefault()}
  >
    {children}
  </Form>
);
